import { cn } from "@/lib/cn";
import { sanitizeArticleHtml, sanitizeMessageHtml } from "./safeHtml";

/**
 * Markup the platform support module produced: a guide's body or a ticket message.
 *
 * The platform sanitizes bodies before it stores them, and this component sanitizes them again on
 * render — DOMPurify against an explicit allowlist per kind (`safeHtml.ts`) — so a row the server let
 * through, or a hostile response, cannot run script in Rigo Accounting. Search excerpts are not HTML
 * and never come here; they render through `Excerpt`. This is the one place Help sets innerHTML, so
 * there is one place to review.
 */
export function PlatformHtml({
  html,
  kind,
  className,
}: {
  html: string;
  kind: "article" | "message";
  className?: string;
}) {
  return (
    <div
      className={cn(
        "text-foreground text-sm leading-relaxed [&_a]:text-primary [&_a]:underline [&_code]:num [&_h2]:mt-5 [&_h2]:text-base [&_h2]:font-semibold [&_h3]:mt-3 [&_h3]:font-semibold [&_img]:max-w-full [&_li]:ml-5 [&_ol]:list-decimal [&_p]:my-2 [&_pre]:overflow-x-auto [&_ul]:list-disc",
        className,
      )}
      // Sanitized on render against the allowlist for its kind; see the remarks above.
      dangerouslySetInnerHTML={{
        __html: kind === "article" ? sanitizeArticleHtml(html) : sanitizeMessageHtml(html),
      }}
    />
  );
}
